export default __webpack_public_path__ + "0117ff9fa85565b44953a383b04e7dd8.png";